require('./bootstrap');
import videojs from "video.js";


if(document.getElementById("vid1")) {
    const player = videojs('vid1', {});
}

window.addEventListener('reload', event => {
    location.reload();
})
